import { render, staticRenderFns } from "./HospitalCard.vue?vue&type=template&id=3b89289e&scoped=true"
import script from "./HospitalCard.vue?vue&type=script&lang=ts"
export * from "./HospitalCard.vue?vue&type=script&lang=ts"
import style0 from "./HospitalCard.vue?vue&type=style&index=0&id=3b89289e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89289e",
  null
  
)

export default component.exports